// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCFGYw9OilooCoBPszK5ITsleQaZV5-a5U",
  authDomain: "chatshop-3d7d2.firebaseapp.com",
  projectId: "chatshop-3d7d2",
  storageBucket: "chatshop-3d7d2.firebasestorage.app",
  messagingSenderId: "148164692275",
  appId: "1:148164692275:web:50548b4004a3a4b46bd646",
  measurementId: "G-YNTBM90K9S",
};

export const app = initializeApp(firebaseConfig);

// ✅ Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// ✅ Firestore
export const db = getFirestore(app);

// ✅ Analytics (щоб не падало там, де не підтримується)
export let analytics = null;
isSupported().then((ok) => {
  if (ok) analytics = getAnalytics(app);
});
